class ApiConfig {
  setTenantId(tenantId) {
    this.tenantId = tenantId;
  }

  setAuthToken(token) {
    this.authToken = token;
  }

  getHttpConfig(addAuthToken, useOldTenantHeader, options) {
    const config = { headers: {} };

    if (this.tenantId) {
      const tenantHeader = useOldTenantHeader ? 'x-mat-tenant' : 'x-vol-tenant';
      config.headers[tenantHeader] = this.tenantId;
    }

    if (addAuthToken && this.authToken) {
      config.headers.Authorization = `Bearer ${this.authToken}`;
    }

    return options ? { ...config, params: options } : config;
  }
}

export default new ApiConfig();



// WEBPACK FOOTER //
// ./src/app/admin/services/api/ApiConfig.js